import { Box, Button, Grid, styled } from "@mui/material";
import { Typography } from "@platform/design-system";

import { CentroCarrierLike, SelectCarrierSvg } from "../../../assets";

const GradientContainer = styled(Box)(() => ({
  background:
    "linear-gradient(89.89deg, rgba(110, 30, 108, 0.9) 38.88%, rgba(0, 120, 162, 0.9) 105.32%, rgba(79, 179, 205, 0.9) 139.34%)",
  borderRadius: 99,
  height: "80px",
  padding: "10px",
  margin: "100px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const OptionBox = styled(Button)(({ $optionSelected }) => ({
  background: "none",
  backgroundColor: $optionSelected ? "#ecf8fc" : "#ffffff",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  width: "200px",
  height: "200px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  margin: "0 10px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#ecf8fc !important",
  },
}));

const InfoText = styled(Box)(() => ({
  marginTop: "20px",
  backgroundColor: "#f9fafb",
  fontStyle: "italic",
  padding: "20px",
  borderRadius: "8px",
  color: "#4a4a4a",
  textAlign: "left",
}));

const StyledOptionText = styled(Typography)(() => ({
  margin: 0,
  fontFamily: "Montserrat, Roman, Arial, sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: 1.75,
  letterSpacing: "0.7px",
  color: "black",
  marginTop: "16px",
}));

const CarrierSelectionOptions = ({
  handleCarrierChange,
  centroCarrierSelected,
  selectedCarriers,
  isOwnCarrierSelected,
}) => (
  <>
    <Typography variant="subtitle1" gutterBottom>
      Select one of the options below—
    </Typography>
    <Box sx={{ textAlign: "center", mt: 6, mb: 6 }}>
      <GradientContainer>
        <Grid container justifyContent="center">
          {/* Option 1 */}
          <OptionBox
            data-testid="carrier-option-centro"
            $optionSelected={centroCarrierSelected}
            onClick={() => handleCarrierChange("centro")}
          >
            <img src={CentroCarrierLike} alt="Centro Carrier" />
            <StyledOptionText variant="subtitle1" sx={{ mt: 2 }}>
              Centro to select Carriers
            </StyledOptionText>
          </OptionBox>

          {/* Option 2 */}
          <OptionBox
            data-testid="carrier-option-own"
            $optionSelected={
              !centroCarrierSelected &&
              (selectedCarriers.length || isOwnCarrierSelected)
            }
            onClick={() => handleCarrierChange("own")}
          >
            <img src={SelectCarrierSvg} alt="Select My Own Carriers" />{" "}
            <StyledOptionText variant="subtitle1" sx={{ mt: 2 }}>
              Select my own Carriers
            </StyledOptionText>
          </OptionBox>
        </Grid>
      </GradientContainer>

      {centroCarrierSelected && (
        <InfoText>
          <Typography variant="body-large">
            Centro will select carriers for this RFP based on lines of coverage,
            company size, geographic region, and industry.
          </Typography>
          <Typography variant="body-large" sx={{ mt: 3 }}>
            Your assigned analyst will communicate the selected carriers prior
            to sending the RFP out to market.
          </Typography>
        </InfoText>
      )}
    </Box>
  </>
);

export default CarrierSelectionOptions;
